export default ({ data, schema }) => (
  Object.entries(schema).reduce((memo, [key, { type }]) => (
    ['Text', 'TextArea', 'Boolean', 'Select'].includes(type) && !data[key]
      ? { ...memo, [key]: (type === 'Boolean' ? false : '') }
      : memo
  ), data)
);
